// Thin fetch wrapper: same-origin API, cookie-carrying, JSON errors surfaced
// with their machine-readable `code` so the UI can branch on cap/availability.

export class ApiError extends Error {
    status: number
    code?: string

    constructor(status: number, message: string, code?: string) {
        super(message)
        this.status = status
        this.code = code
    }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
    const res = await fetch(path, {
        credentials: 'include',
        headers: { 'content-type': 'application/json', ...init?.headers },
        ...init,
    })
    if (!res.ok) {
        let message = res.statusText
        let code: string | undefined
        try {
            const body = (await res.json()) as { error?: string; code?: string }
            message = body.error ?? message
            code = body.code
        } catch {
            // non-JSON error body; keep statusText
        }
        throw new ApiError(res.status, message, code)
    }
    return (await res.json()) as T
}

export function getJson<T>(path: string, init?: RequestInit): Promise<T> {
    return request<T>(path, init)
}

export function postJson<T>(path: string, body: unknown): Promise<T> {
    return request<T>(path, { method: 'POST', body: JSON.stringify(body) })
}
